export default (value) => {
  if (value === null) return ''
  const stringValue = typeof value === 'string' ? value : `${value}`
  return stringValue.replace('.', ',')
}
